import { addDays, addHours, isWeekend, roundToNearestHours, startOfHour } from "date-fns";

import { getNextWeekday, getWeekdayByDate, setTime } from "./date";

export interface SmartDateOptions {
  policy?: "avoid_weekend" | "include_weekend";
}

export function calculateSurveyDates(
  currentDate: Date = new Date(),
  config: SmartDateOptions = {},
): { startDate: Date; endDate: Date } {
  let surveyStartDate: Date;

  const isFridayAfternoon = getWeekdayByDate(currentDate) === "Fri" && currentDate.getHours() >= 15;

  const isBefore3PM = currentDate.getHours() <= 15;

  if (isWeekend(currentDate) || isFridayAfternoon) {
    surveyStartDate = startOfHour(setTime(getNextWeekday(currentDate, "Mon"), 9, 0));
  } else if (isBefore3PM) {
    surveyStartDate = roundToNearestHours(addHours(currentDate, 3), { roundingMethod: "ceil" });
  } else {
    surveyStartDate = startOfHour(setTime(addDays(currentDate, 1), 9, 0));
  }

  const surveyEndDate = calculateSurveyEndDate(surveyStartDate, config);

  return { startDate: surveyStartDate, endDate: surveyEndDate };
}

export function calculateSurveyEndDate(startDate: Date, options: SmartDateOptions = {}): Date {
  const { policy = "avoid_weekend" } = options;

  // End date is start date + 10 days at 23:59
  const endDate = setTime(addDays(startDate, 10), 23, 59);

  // Apply weekend policy for end date
  if (policy === "avoid_weekend" && isWeekend(endDate)) {
    return setTime(getNextWeekday(endDate, "Mon"), 9, 0);
  }

  return endDate;
}
